var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/misc/loader"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M8.23791 3C7.97493 3 7.76172 3.20352 7.76172 3.45455V5.27273C7.76172 5.52376 7.97493 5.72728 8.23791 5.72728C8.5009 5.72728 8.71411 5.52376 8.71411 5.27273V3.45455C8.71411 3.20352 8.5009 3 8.23791 3Z",
    fill: "#2D50A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M8.23791 10.2727C7.97493 10.2727 7.76172 10.4762 7.76172 10.7273V12.5455C7.76172 12.7965 7.97493 13 8.23791 13C8.5009 13 8.71411 12.7965 8.71411 12.5455V10.7273C8.71411 10.4762 8.5009 10.2727 8.23791 10.2727Z",
    fill: "#73A1FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M6.55432 5.75015L5.20743 4.46445C5.02152 4.28693 4.72 4.28693 4.53401 4.46445C4.34804 4.64197 4.34804 4.92976 4.53401 5.10726L5.88089 6.39297C5.97387 6.48172 6.09576 6.52611 6.21759 6.52611C6.33943 6.52611 6.46134 6.48172 6.55428 6.39297C6.74029 6.21545 6.74029 5.92767 6.55432 5.75015Z",
    fill: "#355EC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M12.5243 7.54544H11.5719C11.3089 7.54544 11.0957 7.74896 11.0957 7.99999C11.0957 8.25103 11.3089 8.45454 11.5719 8.45454H12.5243C12.7873 8.45454 13.0005 8.25103 13.0005 7.99999C13.0005 7.74896 12.7873 7.54544 12.5243 7.54544Z",
    fill: "#C4D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M10.5941 9.60708C10.4082 9.42956 10.1067 9.4296 9.92071 9.60708C9.73474 9.7846 9.73478 10.0724 9.92071 10.2499L11.2676 11.5355C11.3606 11.6243 11.4825 11.6687 11.6044 11.6687C11.7262 11.6687 11.8481 11.6243 11.9411 11.5355C12.127 11.358 12.127 11.0702 11.9411 10.8927L10.5941 9.60708Z",
    fill: "#C4D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M5.85715 7.99999C5.85715 7.74896 5.64394 7.54544 5.38096 7.54544H3.4762C3.21321 7.54544 3 7.74896 3 7.99999C3 8.25103 3.21321 8.45454 3.4762 8.45454H5.38096C5.64394 8.45454 5.85715 8.25103 5.85715 7.99999Z",
    fill: "#3D6DEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M6.5543 9.60708C6.36836 9.42956 6.06683 9.42956 5.88087 9.60708L4.53401 10.8927C4.34804 11.0702 4.34804 11.358 4.53401 11.5355C4.62699 11.6243 4.74887 11.6687 4.87074 11.6687C4.99261 11.6687 5.1145 11.6243 5.20743 11.5355L6.5543 10.2499C6.74027 10.0724 6.74027 9.7846 6.5543 9.60708Z",
    fill: "#5286FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader1);
export default __webpack_public_path__ + "static/media/loader1.a8207ccb.svg";
export { ForwardRef as ReactComponent };